

import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const recipes =
{
    namespaced: true,
    state: {
        recipes: [],
        recipe: {}
    },
    mutations: {

    },
    actions: {

        getRational({ commit }, { id, recipeName }) {
            return axios({
                method: 'GET',
                url: baseUrl + 'WordDocs/generateRational/' + id,
                responseType: 'blob',
                withCredentials: true
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Rational for ${recipeName}.docx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(error => console.log(error))
        },
        getSDS({ commit }, { id, recipeName }) {
            return axios({
                method: 'GET',
                url: baseUrl + 'WordDocs/generateSDS/' + id,
                responseType: 'blob',
                withCredentials: true
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `SDS for ${recipeName}.docx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(error => console.log(error))
        },
        getLabel({ commit }, { id, recipeName }) {
            return axios({
                method: 'GET',
                url: baseUrl + 'WordDocs/generateLabel/' + id,
                responseType: 'blob',
                withCredentials: true
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Label for ${recipeName}.docx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(error => console.log(error))
        }

    },
    getters: {}
}

export default recipes